export { NewCarsOffers } from './lib/new-cars-offers'
export { getStaticProps } from './lib/get-static-props'
